import { Component, Input } from '@angular/core';
import { ActiveFilterChip, ProposalsFilterComponent } from '../proposals-filter/proposals-filter.component';

// Filtros aplicados como chips removíveis, fora do painel de filtros
// (ex.: "Tag: cartão ×" + "Limpar filtros"). Some quando não há filtros.
@Component({
    selector: 'app-active-filter-chips',
    templateUrl: './active-filter-chips.component.html',
})
export class ActiveFilterChipsComponent {
    @Input() filter?: ProposalsFilterComponent;
    // on-brand sobre o cabeçalho azul; default em fundo branco
    @Input() variant: 'on-brand' | 'default' = 'default';
    // esconde o 'Limpar filtros' quando a tela já oferece a ação (ex.: estado vazio)
    @Input() showClear = true;

    trackChip(_: number, chip: ActiveFilterChip): string {
        return chip.key + ':' + (chip.value ?? '');
    }
}
